import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TabElementContent } from './models/TabElement';

@Component({
  selector: 't-llevo-detail-tab-item',
  standalone: true,
  imports: [NgClass],
  template: `
    <table class="{{contentClasses}}" [ngClass]="contentClasses? contentClasses : ''">
      @for(item of data; track item.name){
      <tr class="property">
        <td class="property__name {{rowClasses}}">{{ item.name }}:</td>
        <td class="property__value {{rowClasses}}">
          {{ item.value }}
        </td>
      </tr>
      }
    </table>
  `,

  styles: `
  .property__value{

  }
  `,
})
export class DetailTabItemComponent {
  @Input({ required: true }) data!: TabElementContent[];
  @Input() contentClasses?: string
  @Input() rowClasses?: string
}
